import {useLazyQuery} from '@apollo/client';
import {boardFromQueries} from 'api';
import {BoardFormListingRequest, BoardFormResponse} from 'models/board/boardDynamicForm.model';

export const useGetAllBoardForms = () => {
    const [refetch, {loading, data}] = useLazyQuery<{allBoardForm: BoardFormResponse[]}, BoardFormListingRequest>(
        boardFromQueries.GET_ALL_BOARD_FORMS,
        {
            fetchPolicy: 'network-only',
        },
    );
    return {getAllBoardFormsLoading: loading, getAllBoardFormsResponse: data?.allBoardForm, getAllBoardForms: refetch};
};
